import DashbManagementPage from './pages/DashbManagementPage';
import DashboardDetailsPage from './pages/DashboardDetailsPage';
import A2030BriefingPage from './pages/A2030BriefingPage';
import GenerateReportPage from './pages/GenerateReportPage';
import B2BRoutesModule from '../b2b-common/B2BRoutesModule';
import WidgetTemplatesPage from './pages/WidgetTemplatesPage';

const reportingRoutes = [
    { path: '/a2030-briefing', element: <A2030BriefingPage />, visibility: 'private' },
    { path: '/dashboards', element: <DashbManagementPage />, visibility: 'private' },
    { path: '/dashboards/:dashboardId', element: <DashboardDetailsPage />, visibility: 'private' },
    { path: '/create', element: <GenerateReportPage />, visibility: 'private' },
    { path: '/widget-templates', element: <WidgetTemplatesPage />, visibility: 'private' },
    { path: '*', element: <h1>Not Found</h1> }
];

const B2BReporting = () => {
    return <B2BRoutesModule routes={reportingRoutes} />;
};

export default B2BReporting;